
let currentPage = 1;
const btn_load_more = document.getElementById("load_more_posts");

if ( typeof( btn_load_more ) != 'undefined' && btn_load_more != null ) {
           
    btn_load_more.addEventListener( 'click', loadMorePosts );

}

function loadMorePosts() {

    currentPage++; //increment page number for each click
    const wp_ajax_url = wpajax.WP_AJAX_URL;
    const postType    = document.querySelector('.load-more').getAttribute('data-post-type');
    const totalPages  = parseInt( document.querySelector('.load-more').getAttribute('data-totalpages') , 10);

    if ( currentPage<=totalPages ) {
        
        let data = new FormData();
        data.append( 'action', 'loadmore_posts' );
        data.append( 'posttype', postType );
        data.append( 'currentpage', currentPage );

        this.innerHTML = 'Laddar...'; //change button text while loading

        let request = new XMLHttpRequest();

        request.open('POST', wp_ajax_url);
        //let params = new URLSearchParams(data);
        //request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.onload = function () {
            //if (this.status >= 200 && this.status < 400) {
            if (this.readyState == 4 && this.status == 200) {

                
                if ( currentPage == totalPages ) { 

                    btn_load_more.style.display = "none"; 
                    
                } else {

                    btn_load_more.innerHTML = 'Visa fler'; //change button text while loading
                    

                }
                let htlmContainer = document.querySelector('#posts__container');
                //htlmContainer.innerHTML += this.responseText;
                htlmContainer.insertAdjacentHTML('beforeend', this.responseText);

                
            } else { // If fail
                console.log(this.response);
            }
        };
        request.onerror = function() {  }; // Connection error
        request.send(data);
        
    }

}
    /* 

    ES6 Aproach!

    fetch( 
        wp_ajax_url,
        { method: "POST",
        credentials: 'same-origin',       
        body: data
    })
    .then(res => res.json() )
    .then( response => { console.log('Success:', response.status ); })
    .catch( error => { console.error('Error:', error); });

    ( response ) => {
        return `${response}: ${response.status} `;
    });
    */

    /* 
    
    jQuery.ajax : Data to be sent to the server. It is converted to a query string, if not already a string. It's appended to the url for GET-requests. See processData option to prevent this automatic processing. Object must be Key/Value pairs. If value is an Array, jQuery serializes multiple values with same key based on the value of the traditional setting (described below).
    
    By default, data passed in to the data option as an object (technically, anything other than a string) will be processed and transformed into a query string, fitting to the default content-type "application/x-www-form-urlencoded".

    */
